import * as React from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import { LeadNotes } from './LeadNotes'
import { OpportunityNotes } from './OpportunityNotes'
import { NoteDetailsProps } from '@user/components/Leads/LeadCard/NotesDrawer/typings'

type Props = {
  entityType: ENTITY_TYPES
  canUpdate: boolean
  showPestPacNote: boolean
  showKnockStatusNote?: boolean
  backToNotes?: boolean
  sortBy: string
  detail: NoteDetailsProps
  setBackToNotes?: (value: boolean, id: number) => void
  locationsStatus: 'pending' | 'success' | 'fail'
}

export const SalesCenterNotes: React.FC<Props> = (props) => {
  const {
    entityType,
    canUpdate,
    showPestPacNote,
    showKnockStatusNote,
    sortBy,
    detail,
    backToNotes = false,
    setBackToNotes,
    locationsStatus,
  } = props
  const { externalLocationId, id } = detail

  switch (entityType) {
    case ENTITY_TYPES.Lead:
      return (
        <LeadNotes
          leadId={id}
          canUpdate={canUpdate}
          showPestPacNote={showPestPacNote}
          showKnockStatusNote={showKnockStatusNote}
          externalLinkId={externalLocationId}
          sortBy={sortBy}
          detail={detail}
          backToNotes={backToNotes}
          setBackToNotes={setBackToNotes}
          locationsStatus={locationsStatus}
        />
      )
    case ENTITY_TYPES.Opportunity:
      return (
        <OpportunityNotes
          opportunityId={id}
          canUpdate={canUpdate}
          showPestPacNote={showPestPacNote}
          showKnockStatusNote={showKnockStatusNote}
          externalLinkId={externalLocationId}
          sortBy={sortBy}
          detail={detail}
          backToNotes={backToNotes}
          setBackToNotes={setBackToNotes}
          locationsStatus={locationsStatus}
        />
      )
  }
}
SalesCenterNotes.displayName = 'SalesCenterNotes'
